
import { defineComponent } from 'vue';
import store from '@/store';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import GatewaysTableComponent from '@/components/transactionsComponents/GatewaysTable.vue';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';

export default defineComponent({
    name: 'GatewaysListPage',
    props: {
        gateways: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        IpgTransactionSkelton,
        GatewaysTableComponent,
        CustomPaginationComponent,
    },
    data() {
        return {
            activeFilterButton: 'APPROVED',
            buttons: [
                { title: 'تاییده شده', value: 'APPROVED' },
                { title: 'در انتظار تایید', value: 'PENDING' },
                { title: 'رد شده', value: 'REJECTED' },
            ],
        };
    },
    computed: {
        getLoadingPanel(): boolean {
            return store.getters['panel/getLoadingPanel'];
        },
        getGateways(): any[] {
            const gateways = store.getters['panel/getGateways'];
            return gateways.filter((el: any) => el.typeGateway === 'BUSINESS');
        },
        getGlobalPagination(): GlobalPagination {
            return store.getters['panel/getGlobalPagination'];
        },
    },
    methods: {
        handelPagination() {
            store.dispatch('panel/getGatewaysRequest');
        },
        setFilterOfGatewayList(type: string): void {
            store.dispatch('panel/getGatewaysRequest', type);
            this.activeFilterButton = type;
        },
    },
    mounted() {
        store.dispatch('panel/getGatewaysRequest', this.activeFilterButton);
    },
});
